import { ReactNode } from 'react';
import { NavTabTrigger } from 'ui/tabsGroup';

export const MITab = ({
  value,
  selectedVal,
  disabled,
  children,
}: {
  value: string;
  selectedVal: string;
  disabled: boolean;
  children: ReactNode;
}) => (
  <NavTabTrigger
    data-test={`${value}-${selectedVal === value ? 'SELECTED' : 'DEFAULT'}`}
    value={value}
    disabled={disabled}
  >
    {children}
  </NavTabTrigger>
);
